import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const OrderGenieSettings = () => {
  const navigate = useNavigate();

  return (
    <div
      className="order-genie-settings-page d-flex flex-column"
      style={{ height: 'calc(100vh - 60px)' }}
    >
      <div className="page-header d-flex align-items-center gap-3 px-4 py-3 border-bottom bg-white flex-shrink-0">
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={15} />
          <span>Back</span>
        </button>
        <div>
          <h5 className="mb-0 fw-semibold">Settings</h5>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0" style={{ fontSize: '0.78rem' }}>
              <li className="breadcrumb-item text-muted">OrderX</li>
              <li className="breadcrumb-item active">Settings</li>
            </ol>
          </nav>
        </div>
      </div>

      <iframe
        title="OrderX Settings"
        src="/order-x/settings-embed"
        style={{ flex: 1, border: 'none', width: '100%', minHeight: 0 }}
      />
    </div>
  );
};

export default OrderGenieSettings;
